import type { BodyShapeOption } from '@/data/bodyShapes'

interface ShapeCardProps {
  option: BodyShapeOption
  selected: boolean
  onSelect: () => void
}

/**
 * Single-select body-shape card. Renders the shape's photography from
 * /public/shapes/<id>.webp — swap the file at that path to update the image
 * without touching code.
 */
export function ShapeCard({ option, selected, onSelect }: ShapeCardProps) {
  const { image } = option
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      className={`fq-shape-card${selected ? ' is-selected' : ''}`}
      onClick={onSelect}
    >
      <div
        className="fq-shape-media"
        style={{ aspectRatio: `${image.width} / ${image.height}` }}
      >
        <img
          src={image.url}
          alt={image.alt}
          width={image.width}
          height={image.height}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="fq-shape-body">
        <div className="fq-shape-shorthand">{option.shorthand}</div>
        <div className="fq-shape-label">{option.label}</div>
        <p className="fq-shape-desc">{option.description}</p>
      </div>
    </button>
  )
}
